import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allClients } from 'app/mocks/data/park/clients'
import { allManagers } from 'app/mocks/data/park/managers'

import { api } from 'app/utils/constants'

import { Client, ClientPayload } from 'app/types/park/client'

export const updateClient = http.patch(
    `${process.env.REACT_APP_API_ADDRESS}/${api.park.clients.DETAILS}`,
    async ({ request, params }) => {
        const { id } = params

        const payload = await request.json()
        const payloadParsed = ClientPayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        const clientFound = allClients.find(
            (client) => client.id.toString() === id,
        )

        // Not found
        if (!clientFound) {
            return new HttpResponse(null, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<Client>({
            ...clientFound,
            ...payloadParsed.data,
            client: allManagers.find(
                (manager) => manager.id === payloadParsed.data.client,
            ),
        })
    },
)
